/**
 * Firebase Analytics 工具函数
 */

'use client';

import { getAnalytics, logEvent as firebaseLogEvent, Analytics } from 'firebase/analytics';
import { getApps } from 'firebase/app';

/**
 * 获取 Analytics 实例
 */
function getAnalyticsInstance(): Analytics | null {
  if (typeof window === 'undefined') return null;
  if (getApps().length === 0) return null;

  try {
    return getAnalytics();
  } catch {
    return null;
  }
}

/**
 * 记录自定义事件
 */
export function logEvent(eventName: string, eventParams?: Record<string, unknown>) {
  const analytics = getAnalyticsInstance();
  if (analytics) {
    firebaseLogEvent(analytics, eventName, eventParams);
  }
}

/**
 * 记录页面浏览
 */
export function logPageView(pagePath: string, pageTitle?: string) {
  logEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle || document.title,
  });
}

/**
 * 记录搜索事件
 */
export function logSearch(searchTerm: string) {
  logEvent('search', {
    search_term: searchTerm,
  });
}

/**
 * 记录用户登录
 */
export function logLogin(method: string) {
  logEvent('login', {
    method,
  });
}

/**
 * 记录按钮点击
 */
export function logButtonClick(buttonName: string, additionalParams?: Record<string, unknown>) {
  logEvent('button_click', {
    button_name: buttonName,
    ...additionalParams,
  });
}

export { FirebaseProvider } from './FirebaseProvider';
